import { HubContext } from "../providers/HubProvider";
import { useContext } from "react";

export default function useHubContext() {
  return useContext(HubContext);
}
